import { TypedUseSelectorHook, useSelector } from "react-redux";
import { useAppDispatch as useAppDispatchBase } from "tsi-common-react/src/apps/reducers";

import { IReduxState } from "./reducers.interfaces";

// Use throughout the app instead of plain `useAppDispatch` and `useAppSelector`
export const useAppDispatch = useAppDispatchBase;
export const useAppSelector: TypedUseSelectorHook<IReduxState> = useSelector;
